import '../src/pharmacist_news/toc_accordion'
import '../src/pharmacist_news/add_params_to_register_links'
import '../src/pharmacist_news/casual_user_register_form_handler'
// TODO: PHARMACIST-10174のABテストで使用している。
//       テスト終了後は不要なら削除する。
import '../src/pharmacist_news/article_footer_banner_handler'
